Attributes of the newly created position profiles for the job ad.

A draft may produce multiple position profiles, e.g. when posting to multiple locations.
